import { computed, reactive } from "vue";
import axios from "axios";
import Cookies from "js-cookie";

export interface Emitente {
  identificador: number;
  nome_municipio: string | null;
  cnpj: string;
  razao: string;
  cnae: number;
  apelido: string | null;
  aliquota_cbs: number;
  utiliza_nfse: boolean;
  has_dominio_integration: boolean;
  bloqueio_select_tipo_frete_nfe: boolean;
  flag_utiliza_rota_frete: boolean;
  regime_tributario: number;
  identificador_estado: number;
  pcredsn: number;
  logo?: string;
  fantasia?: string;
  telefone?: string;
  email?: string;
  seguradora?: string;
}

const state = reactive({
  emitente: { cnae: 0 } as Partial<Emitente>,
  emitenteId: Cookies.get("emitente_id") || "",
  emitentes: [] as Emitente[],
});

const emitente = computed(() => state.emitente);
const isComercio = computed(() => state.emitente.cnae == 47);

/** @deprecated returns a non-reactive snapshot — use the `emitente` computed instead. */
const getEmitente = () => state.emitente;
/** @deprecated returns a non-reactive snapshot — use `emitente.value.identificador` instead. */
const getEmitenteId = () => state.emitenteId;
const getEmitentes = () => state.emitentes;
const isUnset = () => !("identificador" in state.emitente);

async function refreshEmitente() {
  const response = await axios.get(`/api/emitentes/${state.emitenteId}`);
  const emitente: Emitente = response.data.data;
  if (Number.isInteger(emitente.identificador)) {
    Cookies.set("emitente_id", String(emitente.identificador));
  }
  state.emitente = emitente;
}

async function fetchEmitentes() {
  const response = await axios.get("/api/users/meus-emitentes");
  state.emitentes = response.data;
}

function setEmitente(emitente: Emitente) {
  if (Number.isInteger(emitente.identificador)) {
    Cookies.set("emitente_id", String(emitente.identificador));
    state.emitente = emitente;
    state.emitenteId = String(emitente.identificador);
  }
}

function hasDominioIntegration() {
  return emitente.value.has_dominio_integration;
}

export default {
  emitente,
  fetchEmitentes,
  getEmitente,
  getEmitenteId,
  getEmitentes,
  isComercio,
  isUnset,
  refreshEmitente,
  setEmitente,
  hasDominioIntegration,
};
